<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { PhArrowRight } from '@phosphor-icons/vue'

import { Button } from '@toni/brand-ui'

import { useSourcepointStore } from '../../../stores/sourcepoint'

const { t } = useI18n()
const sourcepointStore = useSourcepointStore()

const openPrivacyManager = () => {
  const sp = (window as unknown as { _sp_?: {
    gdpr?: { loadPrivacyManagerModal: (id: string) => void}
} })._sp_

  if (
    sp &&
    typeof sp?.gdpr?.loadPrivacyManagerModal === 'function' &&
    sourcepointStore.consentConfig?.privacyManagerId
  ) {
    try {
      sp.gdpr.loadPrivacyManagerModal(sourcepointStore.consentConfig.privacyManagerId)
    } catch (error) {
      console.error('Failed to load privacy manager modal:', error)
    }
  } else {
    console.warn('Privacy manager not available.', {
      spExists: !!sp,
      loadMethodExists: typeof sp?.gdpr?.loadPrivacyManagerModal === 'function',
      privacyManagerId: sourcepointStore.consentConfig?.privacyManagerId
    })
  }
}
</script>

<template>
  <div class="flex justify-center w-full mt-5 mb-11">
    <Button
      variant="primary"
      size="xl"
      type="regular"
      @click="openPrivacyManager">
      {{ t('privacyManager.open') }}
      <span class="flex-shrink-0">
        <PhArrowRight
          weight="bold"
          class="w-5 h-5" />
      </span>
    </Button>
  </div>
</template>
